import * as React from "react";

interface IPasswordRulesState {}

interface IPasswordRulesProps {
  style?: any;
  className?: string;
}

export default class PasswordRules extends React.Component<
  IPasswordRulesProps,
  IPasswordRulesState
> {
  constructor(props: any) {
    super(props);
    this.state = {};
  }

  public render() {
    return (
      <div>
          <div
            style={
              this.props.style
                ? this.props.style
                : {
                    color: "#666666",
                    marginTop: 5,
                    marginBottom: 10,
                    paddingLeft: 10,
                    fontFamily: "SF Pro Text",
                    fontStyle: "normal",
                    fontWeight: 500,
                    fontSize: "14px",
                    lineHeight: "18px",
                  }
            }
            className={this.props.className ? this.props.className : ""}
          >
            Passwords must be at least 8 characters long and avoid commonly used
            phrases.
          </div>
      </div>
    );
  }
}
